export default {
  title: "Contact",
  responsible_firstname: "Responsible Firstname",
  responsible_lastname: "Responsible Lastname",
  responsible_phone: "Responsible Contact Number",
  edit_contact: "Edit Contact",
  email: "Email",
  not_especified: "--",
};
